import {combineReducers} from "redux";
import {reduceLatestQuery, reduceRequestState, reduceResponse, reduceResponseField, RequestState} from "@web2/ap-request-state";

import {fetchAgentsListActionTypes} from "../actions/fetch_agent_list";
import {applicationsListFetchActionTypes} from "../actions/fetch_applicactions";

export enum ApplicationCallStatus {
    APPLICATION_CALL_STATUS_ANSWERED = 1,
    APPLICATION_CALL_STATUS_NO_ANSWER = 2,
    APPLICATION_CALL_STATUS_BUSY = 3,
    APPLICATION_CALL_STATUS_NOT_A_CALL = 4,
    APPLICATION_CALL_STATUS_FAILD = 5
}

export enum ApplicationSourceGroup {
    FORM_APPLICATION = 1,
    PHONE_APPLICATION = 2
}

export interface IAPApplication {
    agency: number;
    agent: number | null;
    agent_name: string | null;
    call_start: string | null;
    call_status: ApplicationCallStatus;
    call_time: number | null;
    clip_id: number | null;
    clip_phone: string | null;
    create_date: string;
    email: string | null;
    name: string | null;
    offer_city: string;
    offer_url: string;
    phone: string | null;
    receiver_phone: string | null;
    remote_id: number | null;
    remote_offer_id: number | null;
    remote_user_contact_id: number | null;
    source: number;
    source_group: ApplicationSourceGroup;
    text: string | null;
}

export interface IAgent {
    name: string;
    last_name: string;
    agent_id: number;
}

export interface ApplicationsStore {
    list: IAPApplication[];
    count: number;
    requestState: RequestState;
    latestQuery: Record<string, string | string[]>;
    agentsList: IAgent[];
}

export const applicationsListReducer = combineReducers({
    list: reduceResponseField<IAPApplication[]>(applicationsListFetchActionTypes, "list", []),
    count: reduceResponseField(applicationsListFetchActionTypes, "count", 0),
    requestState: reduceRequestState(applicationsListFetchActionTypes),
    latestQuery: reduceLatestQuery(applicationsListFetchActionTypes),
    agentsList: reduceResponse(fetchAgentsListActionTypes, [])
});
